import axios from '@/service/interceptor';
import settings from '@/utils/settings';

function getHistory(userId, type = 'listDeposits', o = 10, l = 10) {
    let data = {
        userid: userId,
        offset: o,
        limit: l,
    };
    let apiPath = `${settings.SERVER_PREFIX}/me`;
    let method = 'post';
    if (type === 'deposit') {
        data = Object.assign(data, {
            cmd: settings.cmd.listDeposits,
        });
    } else if (type === 'withdraw') {
        data = Object.assign(data, {
            cmd: settings.cmd.listWithdraws,
        });
    } else if (type === 'transfer') {
        data = Object.assign(data, {
            cmd: settings.cmd.listTransfer,
        });
    } else if (type === 'fiat') {
        apiPath = 'https://payment.bytetrade.com/getTransactions';
        method = 'post';
        data = Object.assign(data, {
            appid: '1',
            channel: 'indacoin',
        });
    }
    const pm = new Promise((resolve, reject) => {
        const params = method === 'get' ? {
            params: data,
        } : data;
        axios[method](apiPath, params).then((res) => {
            if (res.data.code === 0) {
                resolve(res.data);
            } else {
                reject(res.data);
            }
        });
    });
    return pm;
}

export default {
    getHistory,
};



// WEBPACK FOOTER //
// ./src/utils/history.js